export default {
  component: () => import("../../../template/Default.vue"),
  children: [
    {
      path: "",
      name: "facturas",
      component: () => import("../components/Facturas"),
    },
  ],
}
